<template>
    
    <div class="popup popup--lang slide-right" id="language-box" v-show="$store.state.languageBox">
        <div class="flex nav">
            <!-- <InputText :type="text" /> -->
            <button class="button button--close" 
                    @click="switchLangBox">
            </button>
            <button class="button button--lang">En</button>
        </div>
        <div class="radiobuttons-list">
            <RadioButton :options="languages" />
        </div>
    </div>

</template>

<script>
import RadioButton from './UIKit/RadioButton.vue';

export default {
    name: 'LangModal',
    components: {
      RadioButton  
    },
    data() {
        return {
            languages: ['English (US)', 'Russian'],
            // languages: [
            //     {
            //         name: 'English (US)',
            //         icon: ''
            //     }, 
            //     {
            //         name: 'Russian',
            //         icon: '' 
            //     }
            // ],
            languageBox: this.$store.state.languageBox
        }
    },
    methods: {
        switchLangBox () {
			this.$store.commit('switchLangBox', !this.$store.state.languageBox)
		}
    }
}

</script>


<style lang="scss">
@import '../colors.scss';
@import '../mixins.scss';

#language-box {

    .radiobuttons-list {
        margin-top: 13%;        

        .radio {
            margin-bottom: 24px;

            span {
                font-size: 24px;
                line-height: 29px;
            }
            .checkmark {
                right: 0;
                left: auto;
            }
        }
    }
}
</style>